// src/components/Sidebar.jsx

import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

const Sidebar = () => {
  const [activeItem, setActiveItem] = useState(null); // Track selected item
  const [hoveredItem, setHoveredItem] = useState(null); // Track hovered item

  const handleItemClick = (index) => {
    setActiveItem(index); // Set the active menu item
  };

  const handleMouseEnter = (index) => {
    setHoveredItem(index); // Set the hovered item
  };

  const handleMouseLeave = () => {
    setHoveredItem(null); // Reset hovered item when mouse leaves
  };

  return (
    <div style={styles.sidebar}>
      <ul style={styles.menu}>
        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 0 || hoveredItem === 0 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(0)}
          onMouseEnter={() => handleMouseEnter(0)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/executive-summary" style={styles.link}>Executive Summary</Link>
        </li>
        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 1 || hoveredItem === 1 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(1)}
          onMouseEnter={() => handleMouseEnter(1)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/companyoverview" style={styles.link}>Company Overview</Link>
        </li>
        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 2 || hoveredItem === 2 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(2)}
          onMouseEnter={() => handleMouseEnter(2)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/marketopportunity" style={styles.link}>Market Opportunity</Link>
        </li>

        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 3 || hoveredItem === 3 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(3)}
          onMouseEnter={() => handleMouseEnter(3)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/inclusionsummary" style={styles.link}>Business Model and Revenue Streams</Link>
        </li>

        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 4 || hoveredItem === 4 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(4)}
          onMouseEnter={() => handleMouseEnter(4)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/pooffering" style={styles.link}>Product And Service Offerings</Link>
        </li>

        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 5 || hoveredItem === 5 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(5)}
          onMouseEnter={() => handleMouseEnter(5)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/techscalability" style={styles.link}>Technology Infrastructure and Scalability</Link>
        </li>

        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 6 || hoveredItem === 6 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(6)}
          onMouseEnter={() => handleMouseEnter(6)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/competitiveadvantage" style={styles.link}>Competitive Advantage</Link>
        </li>

        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 7 || hoveredItem === 7 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(7)}
          onMouseEnter={() => handleMouseEnter(7)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/marketgrowthstrategy" style={styles.link}>Market And Growth Strategy</Link>
        </li>

        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 8 || hoveredItem === 8 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(8)}
          onMouseEnter={() => handleMouseEnter(8)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/financialprojections" style={styles.link}>Financial Projections and Analysis</Link>
        </li>

        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 9 || hoveredItem === 9 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(9)}
          onMouseEnter={() => handleMouseEnter(9)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/investment" style={styles.link}>Investment Requiremnet, Valuation, and Equity Offering</Link>
        </li>

        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 10 || hoveredItem === 10 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(10)}
          onMouseEnter={() => handleMouseEnter(10)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/riskandmitigation" style={styles.link}>Risk Analysis and Mitigation Strategies</Link>
        </li>

        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 11 || hoveredItem === 11 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(11)}
          onMouseEnter={() => handleMouseEnter(11)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/exitstrategy" style={styles.link}>Exit Strategy And Investor Returns</Link>
        </li>

        <li
          style={{
            ...styles.menuItem,
            ...(activeItem === 12 || hoveredItem === 12 ? styles.activeOrHoveredMenuItem : {}),
          }}
          onClick={() => handleItemClick(12)}
          onMouseEnter={() => handleMouseEnter(12)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to="/know-more/conclusion" style={styles.link}>Conclusion and Investor Engagement</Link>
        </li>
      </ul>
    </div>
  );
};

const styles = {
  sidebar: {
    width: '240px',
    height: '85vh', // Full height of the screen
    backgroundColor: '#321E5D',
    color: '#fff',
    padding: '20px',
    position: 'fixed', // Keeps the sidebar in place when scrolling
    top: '80px', // Aligns it with the top of the page
    marginLeft: '20px',
    borderRadius: '15px',
    overflowY: 'auto', // Enable vertical scrolling
    boxSizing: 'border-box', // Ensures padding is included in the height
  },
  menu: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  menuItem: {
    marginBottom: '15px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease', // Smooth transition for background color change
    padding: '10px', // Add some padding for better clickable area
    borderRadius: '5px', // Optional: rounded corners for menu items
  },
  activeOrHoveredMenuItem: {
    backgroundColor: '#936fe0', // Background color for hover and active
    color: '#fff', // Ensure text remains white
  },
  link: {
    color: '#fff',
    textDecoration: 'none', // Remove underline
    display: 'block', // Make the whole item clickable
  },
};

export default Sidebar;
